import { render } from "./TabBar.vue?vue&type=template&id=5743cb5a&scoped=true"
import script from "./TabBar.vue?vue&type=script&lang=js"
export * from "./TabBar.vue?vue&type=script&lang=js"

import "./TabBar.vue?vue&type=style&index=0&id=5743cb5a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5743cb5a"],['__file',"src/scripts/common/components/TabBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5743cb5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5743cb5a', __exports__)) {
    api.reload('5743cb5a', __exports__)
  }
  
  module.hot.accept("./TabBar.vue?vue&type=template&id=5743cb5a&scoped=true", () => {
    api.rerender('5743cb5a', render)
  })

}


export default __exports__